<template>
	<div class="max-w-7xl mx-auto py-6">
		<Card v-if="assetForm">
			<template #title>{{ $t('pages.assets.asset.properties.edit_asset') }}</template>
			<template #content>
				<AssetPropertiesForm
						:form="assetForm"
						:is-disabled="!$auth.hasPermission('update:assets')"
						@on-save="saveAsset"
						@on-reset="assetForm.reset()"
				/>
			</template>
		</Card>
	</div>
</template>

<script>
import AssetPropertiesForm from "@/Forms/Asset/AssetPropertiesForm.vue";
import { mapStores } from "pinia";
import { useAssetsStore } from "@/stores/assets.js";

export default {
	name: "AssetPropertiesView",
	components: {AssetPropertiesForm},
	data() {
		return {
			assetForm: undefined,
		}
	},
	computed: {
		...mapStores(useAssetsStore),
	},
	methods: {
		async saveAsset() {
			try {
				await this.assetForm.submit();
				this.$emit('on-save');
			} catch (error) {
				//
			}
		},
	},
	watch: {
		'$route.params.asset': {
			async handler(newValue, oldValue) {
				if (newValue) {
					if (this.$route.params.asset === 'NEW') {
						this.assetForm = await this.assetsStore.createAsset();
					} else {
						this.assetForm = await this.assetsStore.editAsset(this.$route.params.asset);
					}
				} else {
					this.assetForm = undefined;
				}
			},
			immediate: true,
		}
	},
}
</script>

<style scoped>

</style>